<!--
 * @description: 服务回访
 * @param: 
 * @return: 
-->
<template>
  <div class="container-serve">
    <div class="condition-list-container">
      <div class="conditon-bontainer">
        <text-field v-model:value="condition.compid" labelText="客户:" :clearable="true" type="select"
          :selectRemoteSearchData="remoteData" class="condition-container-input"></text-field>
        <text-field v-model:value="condition.shooincomp" labelText="联系人:" :clearable="true"
          class="condition-container-input" />
        <text-field v-model:value="condition.startTime" type="date" labelText="寄送起始日期:" clearable
          class="condition-container-input">
        </text-field>
        <text-field v-model:value="condition.end" type="date" labelText="寄送结束日期:" clearable
          class="condition-container-input">
        </text-field>

        <text-field v-model:value="condition.linkMan" labelText="寄送单号:" class="condition-container-input">
        </text-field>
        <text-field v-model:value="condition.sn" labelText="SN:" class="condition-container-input">
        </text-field>
      </div>

      <div class="btn-container">
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <div class="main-container">
      <div class="header-container">
        <div class="title">服务回访记录列表</div>
        <div class="btnHandle" @click="handleAdd">
          添加
        </div>
      </div>
      <div class="tabel-container">
        <el-table ref="tableInstance" @selection-change="tableSelection" :data="tableData" style="width: 100%"
          @cell-dblclick="rowDbClick" border stripe highlight-current-row height="401"
          header-row-class-name="header-row-class-name" header-cell-class-name="header-row-class-name">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column :show-overflow-tooltip="true" prop="CompName" label="客户" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="LinkMan" label="联系人" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="TelNo" label="联系电话" width="100" resizable align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="Phone" label="联系手机" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="Email" label="邮箱" width="width" resizable align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="Fax" label="传真" width="width" resizable align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="Post" label="邮编" width="width" resizable align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="ModelNoName" label="型号" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="SerialNoName" label="SN" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="Address" label="地址" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" 
          sortable
          prop="TranDate" label="寄送日期" width="120" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="TransferNo" label="寄送单号" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="IsFinish" label="归还" width="width" resizable
           sortable
           
           align="center">
            <template #default="{ row }">
              {{ row.IsFinish == "是" ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="Phone" label="结单" width="width" resizable align="center">
            <template #default="{ row }">
            
              <div class="style-aaa" @click="handleDone(row)">结单</div>
              <!-- <el-button @click="handleDone(row)">
                <i class="el-icon-check"></i>
              </el-button> -->
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="Phone" label="删除" width="width" resizable align="center">
            <template #default="{ row }">
              <div class="style-aaa" @click="handleDelete(row)">删除</div>
              <!-- <el-button @click="handleDelete(row)">
              
                <i class="el-icon-delete"></i>
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation-container">
        <el-pagination background :page-size="pageSize" :total="rowsCount" :pager-count="pagerCount" :prev-text="'上一页'"
          :next-text="'下一页'" @current-change="pageChange" @size-change="sizeChange"
          layout="sizes,total, prev, pager, next, jumper,slot" style="margin-top: 20px;">
          <template #default>
            <el-button size="mini" @click="refresh">刷新</el-button>
          </template>
        </el-pagination>
      </div>
    </div>
    <!-- 备机详情 -->
    <el-dialog v-model="dialogFormVisible" title="备机借用详细" width="80%">
      <div class="condition-panel">
        <div class="form-dialog-condition-one">
          <text-field v-model:value="dialogFormData.row.CompName" labelText="客户:" :readOnly="true" :clearable="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormData.row.LinkMan" labelText="联系人:" :readOnly="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormData.row.TranDate" labelText="寄送日期:" :readOnly="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormData.row.TransferNo" labelText="寄送单号:" :readOnly="true"
            class="condition-container-input"></text-field>
        </div>
      </div>
      <div class="data-show-panel">
        <div class="serve-list">备机借用详细信息</div>
        <el-table :data="dialogFormData.list" style="width: 100%" height="400">
          <el-table-column prop="BrandName" label="品牌" width="width" align="center">
          </el-table-column>
          <el-table-column prop="ProCateName" label="产品" width="width" align="center">
          </el-table-column>
          <el-table-column prop="ModelNoName" label="型号" width="width" align="center">
          </el-table-column>
          <el-table-column prop="SerialNoName" label="SN" width="width" align="center">
          </el-table-column>
          <el-table-column prop="AttachName" label="附件" width="width" align="center">
          </el-table-column>
          <el-table-column prop="PreMachDesc" label="备注" width="width" align="center">
          </el-table-column>
          <el-table-column prop="ReCompName" label="归还地" width="width" align="center">
          </el-table-column>
          <el-table-column prop="ReturnDate" label="归还日期" width="width" align="center">
          </el-table-column>
          <el-table-column prop="ReTransferNo" label="归还单号" width="width" align="center">
          </el-table-column>
          <el-table-column prop="IsReturn" label="归还" width="width" align="center">
          </el-table-column>
          <el-table-column prop="IsReturn" label="寄回" width="width" align="center">
            <template #="{ row }">
              <span v-if="!row.IsReturn" @click="handlSendBack(row)">寄回</span>
              <!-- !row.IsReturn -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background :page-size="pageSizeDia" :total="rowsCountDia" :pager-count="pagerCount"
          :prev-text="'上一页'" :next-text="'下一页'" @current-change="pageChangeDia" @size-change="sizeChangeDia"
          layout="sizes,total, prev, pager, next, jumper,slot" style="margin-top: 20px;">
          <template #default>
            <el-button size="mini" @click="refreshDia">刷新</el-button>
          </template>
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 备机寄回编辑信息 -->
    <el-dialog v-model="sendBackDialog" title="备机寄回编辑信息" width="30%" top="15%">
      <el-form ref="form" :model="sendBackForm" label-width="80px">
        <el-form-item label="返回地">
          <el-select v-model="sendBackForm.compid" placeholder="请选择" size="small">
            <el-option v-for="item in sendBackForm.options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="寄回单号">
          <el-input v-model="sendBackForm.TranNo" size="small" />
        </el-form-item>

        <el-form-item label="寄回日期">
          <el-date-picker v-model="sendBackForm.TranDate" type="date" placeholder="选择日期" style="width: 100%"
            size="small" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button type="primary" @click="sendBackSave">保存</el-button>
      </template>
    </el-dialog>
    <!-- 添加 -->
    <el-dialog v-model="dialogAdd" title="备机借用详细" @close="dialogAddClose" width="80%">
      <div class="condition-panel">
        <div class="form-dialog-condition-one">
          <text-field v-model:value="dialogFormDataAdd.compId" labelText="客户:" :clearable="true" type="select"
            :selectRemoteSearchData="remoteData" class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataAdd.CusCopmany_Id" labelText="公司联系人:" :clearable="true" type="select"
            :selectChildData="options.CusCopmany_Id" class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataAdd.LinkMan" labelText="联系人:" class="condition-container-input">
          </text-field>
          <text-field v-model:value="dialogFormDataAdd.TelNo" labelText="联系电话:" class="condition-container-input">
          </text-field>
          <text-field v-model:value="dialogFormDataAdd.Phone" labelText="联系手机:" class="condition-container-input">
          </text-field>
        </div>
        <div class="form-dialog-condition-one">
          <text-field v-model:value="dialogFormDataAdd.Email" labelText="Email:" class="condition-container-input">
          </text-field>
          <text-field v-model:value="dialogFormDataAdd.Fax" labelText="传真:" class="condition-container-input">
          </text-field>
          <text-field v-model:value="dialogFormDataAdd.Post" labelText="编码:" class="condition-container-input">
          </text-field>
          <text-field v-model:value="dialogFormDataAdd.Address" labelText="地址:" class="condition-container-input">
          </text-field>
        </div>

        <div class="form-dialog-condition-one">
          <text-field v-model:value="dialogFormDataAdd.TransferNo" labelText="货运单号:" class="condition-container-input">
          </text-field>
          <text-field v-model:value="dialogFormDataAdd.trcombId" labelText="货运公司:" :clearable="true" type="select"
            :selectChildData="options.shippingCompany" class="condition-container-input"></text-field>
          <text-field :clearable="true" type="select" v-model:value="dialogFormDataAdd.trmthId" labelText="运输方式:"
            :selectChildData="options.shippingMethod" class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataAdd.TranDate" labelText="寄送日期:" :clearable="true" type="date"
            class="condition-container-input"></text-field>
        </div>
      </div>
      <div class="data-show-panel">
        <div class="serve-list-add">
          <span class="add-style add-point" @click="handleDialogAddFj">添加</span>
          <span class="add-point" @click="handleSubmit">提交</span>
        </div>
        <el-table :data="dialogFormDataAdd.list" style="width: 100%" height="380">
          <el-table-column prop="BrandId" label="品牌" width="width">
          </el-table-column>
          <el-table-column prop="ProductId" label="产品" width="width">
          </el-table-column>
          <el-table-column prop="ModelNoId" label="型号" width="width">
          </el-table-column>
          <el-table-column prop="sn" label="SN" width="width">
          </el-table-column>
          <el-table-column prop="AttachName" label="附件" width="width">
          </el-table-column>
          <el-table-column prop="PreMachDesc" label="备注" width="width">
          </el-table-column>
          <el-table-column prop="Appendix" label="状态" width="width">
          </el-table-column>
          <el-table-column prop="Appendix" label="删除" width="width">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 添加-添加包含附件 
   
    -->
    <el-dialog v-model="sendBackDialogAddFJ" title="备机设备编辑信息" width="40%" top="15%" @close="sendBackDialogAddFJClose">
      <div class="add-fj-container">
        <div class="add-row">
          <text-field v-model:value="conditionAdd.BrandId" labelText="品牌名称:" :clearable="true" type="select"
            class="condition-container-input" :selectChildData="options.compid" @change="handleCompid" />
          <div>
            产品类别:
            <el-select v-model="conditionAdd.ProductId" placeholder="产品类别"
            @change="handleProductId"
            >
              <el-option
                v-for="item in options.ProductId"
                :key="item.value"
                :label="item.label"
                :value="item.value"
               
              />
            </el-select>
          </div>
          <!-- 
            <text-field v-model:value="conditionAdd.ProductId" labelText="产品类别:" :clearable="true" type="select"
            class="condition-container-input" :selectChildData="options.ProductId" @change="handleProductId" /> -->

        </div>
        <div class="add-row">
          <div>
            产品型号:
            <el-select v-model="conditionAdd.ModelNoId" placeholder="产品型号">
              <el-option
                v-for="item in options.ModelNoId"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>

          <div>
            sn:
            <el-input v-model="conditionAdd.sn" type="text" placeholder="sn" />
          </div>
          <!-- <text-field v-model:value="conditionAdd.ModelNoId" labelText="产品型号:" :clearable="true" type="select"
            class="condition-container-input" :selectChildData="options.ModelNoId" /> -->
          
            
            
          
          <!-- <text-field v-model:value="conditionAdd.sn" labelText="SN:" :clearable="true"
            class="condition-container-input" /> -->
        </div>
        <div class="add-row">
          <div class="text-container">
            <div class="text">附件:</div>
            <div v-if="fjData.length">
              <el-checkbox-group v-model="conditionAdd.Attach">
                <el-checkbox v-for="item in fjData" :key="item.id" :label="item.Name"
                  :model-value="item.id" />
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="add-row">
          <div class="text-container">
            <div class="text">备注:</div>
            <div>
              <el-input v-model="conditionAdd.PreMachDesc" :rows="4" type="textarea" resize="none" />
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <el-button type="primary" @click="sendBackSaveAdd">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import { defineComponent, reactive, toRefs, watch, ref, onMounted } from "vue";
import tableApi from "@/api/tabel.js";
import { ElMessageBox } from 'element-plus'
import { errMsg, successMsg } from "@/notify/index.js";
export default defineComponent({
  name: "messageCenter",
  components: {
    textField,
    tabelPanel,
    popDialog,
  },
  props: {},
  emits: [],

  setup(props, { emit }) {
    const data = reactive({
      tabelSelectionList: [],
      tableInstance: null,
      dialogFormVisible: false, //dialog
      sendBackDialog: false,
      dialogAdd: false,
      sendBackDialogAddFJ: false,
      pagerCount: 7, //总页按钮数，超过当前数会折叠
      rowsCount: 100, //总条数
      rowsCountDia: 100,
      pageSize: 20, //每页条数
      pageSizeDia: 20,
      currentIndex: 1, //当前页数
      currentIndexDia: 1, //当前页数
      abc: "",
      condition: {},
      conditionAdd: {
        Attach: [],
      },
      options: {
        compid: [],
        ProductId: [],
        ModelNoId: [],
        CusCopmany_Id: [],
        shippingCompany: [],
        shippingMethod: [],
      },
      tableData: [],
      dialogFormData: { row: {} },
      dialogFormDataAdd: {
        list: [],
      },
      sendBackForm: {},
      rowId: "",
      fjData: [{
        id: 1,
        Name: "k"
      }],
    });
    onMounted(() => {
      methods.getSource();
      methods.getCompan();
      methods.getPinP();
      methods.getSendCom();
    });
    watch(
      () => {
        return data.dialogFormDataAdd?.compId;
      },
      (newV, oldV) => {
        if (!newV) return;
        tableApi.linkMan({ Company_Id: newV }).then((res) => {
          console.log(res, "watchres");
          data.options.CusCopmany_Id = res.data.list.map((i) => ({
            label: i.LinkMan,
            value: i.id,
            ...i,
          }));
        });
      }
    );
    watch(
      () => {
        return data.dialogFormDataAdd?.CusCopmany_Id;
      },
      (newV, oldV) => {
        if (newV) {
          const obj = data.options.CusCopmany_Id.filter((i) => i.id == newV);
          data.dialogFormDataAdd.LinkMan = obj[0].LinkMan;
          data.dialogFormDataAdd.TelNo = obj[0].TelNo;
          data.dialogFormDataAdd.Phone = obj[0].Phone;
          data.dialogFormDataAdd.Email = obj[0].Email;
          data.dialogFormDataAdd.Address = obj[0].Address;
          data.dialogFormDataAdd.Post = obj[0].PostNo;
          data.dialogFormDataAdd.Fax = obj[0].FaxNo;
          //  debugger
        }
      }
    );
    let methods = {
      // 货运方式 货运公司
      getSendCom() {
        // gongsi
        tableApi.TransComp().then((res) => {
          data.options.shippingCompany = res.data.list.map((i) => ({
            label: i.Name,
            value: i.id,
          }));
        });
        //运输方法 TransMethod
        tableApi.TransMethod().then((res) => {
          // console.log(res,'ressssssss运输方式')
          data.options.shippingMethod = res.data.list.map((i) => ({
            label: i.Name,
            value: i.Id,
          }));
        });
      },
      // 获取品牌信息
      async getPinP() {
        const res = await tableApi.BrandSelect();
        if (res.code == 0) {
          const {
            data: { list },
          } = res;
          data.options.compid = list.map((item) => ({
            label: item.Name,
            value: item.id,
          }));
        }
      },
      async handleCompid(v) {
        console.log(v);
        data.conditionAdd.ModelNoId = "";
        data.conditionAdd.ProductId = "";
        if (!v) return;

        const res = await tableApi.ProductSelect({ Bid: v });
        if (res.code == 0) {
          const {
            data: { list },
          } = res;
          data.options.ProductId = list.map((item) => ({
            label: item.Name,
            value: item.id,
          }));
        }
      },
      async handleProductId(v) {
        console.log("产品类型",v)
        data.conditionAdd.ModelNoId = "";
        // data.fjData = []
        if (!v) return;
        console.log("产品data.fjData",data.fjData)
        const resFjData = await tableApi.AttachSelect(v)
        if ( resFjData.code == 0 ) {
          data.fjData = resFjData.data.list
        }
        // .then((res) => {
        //   console.log( "附件",res);
        //     data.fjData = res.data.list;
        //     console.log( "附件data.fjData",data.fjData);
        // });
        
        const res = await tableApi.modelSelect({ ProductCategoryId: v });
        if (res.code == 0) {
          const {data: { list }} = res;
          console.log( "型号--",list);
          data.options.ModelNoId = list.map((item) => ({
            label: item.Name,
            value: item.id,
          }));
        }
      },
      // 客户数据
      async remoteData() {
        let source = await tableApi.CompanyInfo();
        if (source.code == 0) {
          let data = source.data.list.map(({ Company_Id, CompName }) => {
            return {
              label: CompName,
              value: Company_Id,
            };
          });
          let total = 0;
          return {
            total,
            data,
          };
        } else {
          errMsg(this, source.message);
        }
      },
      getCompan() {
        tableApi.CompanyInfo().then((res) => {
          data.sendBackForm.options = res.data.list.map((i) => ({
            label: i.CompName,
            value: i.Company_Id,
          }));
        });
      },
      getSource(
        obj = {
          compid: null,
          odd: null,
          startTime: null,
          end: null,
          linkMan: null,
          sn: null,
          page: data.currentIndex,
          limit: data.pageSize,
        }
      ) {
        tableApi.PreMachineMangeSearch(obj).then((res) => {
          console.log(res, "服务回访res");
          data.tableData = res.data.list;
          data.rowsCount = res.data.count;
        });
      },
      handleSearch() {
        const params = {
          page: data.currentIndex,
          limit: data.pageSize,
          ...data.condition,
        };
        methods.getSource(params);
      },
      pageChange(pageIndex, limit) {
        data.currentIndex = pageIndex;
        methods.getSource();
        console.log("页数改变", pageIndex, limit);
      },
      pageChangeDia(pageIndex, limit) {
        data.currentIndexDia = pageIndex;
        methods.getBeiJiXQ(pageIndex, data.pageSizeDia);
        console.log("页数改变", pageIndex, limit);
      },
      sizeChange(v) {
        data.pageSize = v;
        methods.getSource();
        console.log("每页条数改变", v);
      },
      sizeChangeDia(v) {
        data.pageSizeDia = v;
        methods.getBeiJiXQ(data.currentIndexDia, v);
        console.log("每页条数改变", v);
      },
      refresh() {
        console.log("刷新");
        methods.getSource();
      },
      refreshDia() {
        console.log("刷新");
        data.pageSizeDia = 10;
        data.currentIndexDia = 1;
        methods.getBeiJiXQ(1, 10);
      },
      rowDbClick(v) {
        data.rowId = v.Id;
        data.dialogFormData.row = v;
        methods.getBeiJiXQ(1, 10);
        data.dialogFormVisible = true;
      },
      getBeiJiXQ(page, limit) {
        tableApi
          .PreMachineMangeDetailSearch({ Id: data.rowId, page, limit })
          .then((res) => {
            data.rowsCountDia = res.data.count;
            data.dialogFormData.list = res.data.list;
            console.log(res, "getBeiJiXQ");
          });
      },
      // 删除
      handleDelete(row) {
        ElMessageBox.confirm("确定删除吗？", '提示', {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: 'warning'
        }).then(() => {
          tableApi.DelPreMachineMangeById({ id: row.Id }).then(res => {
            successMsg("删除成功")
            methods.refresh()
          })
        }).catch(() => { })

      },
      // 结单
      handleDone(row) {
        // if (row.IsFinish == "是") {
        //   errMsg("该设备已寄回");
        //   return;
        // }
        data.sendBackForm.id = row.Id;
        data.sendBackDialog = true;
      },
      //   备机寄回
      handlSendBack(row) {
        data.sendBackForm.id = row.Id;
        data.sendBackDialog = true;
        //   tableApi.PreMachineMangeDetailFinishById()
      },
      sendBackSave() {
        const obj = {
          id: data.sendBackForm.id,
          cmp: data.sendBackForm.compid,
          trn: data.sendBackForm.TranNo,
          rdt: data.sendBackForm.TranDate,
        };
        if (
          !data.sendBackForm.compid ||
          !data.sendBackForm.TranNo ||
          !data.sendBackForm.TranDate
        ) {
          errMsg("请填写信息");
          return;
        }
        tableApi.PreMachineMangeFinishByIdNew(obj).then((res) => {
          data.sendBackDialog = false;
          // methods.getBeiJiXQ(1, 10);
        methods.getSource();

        });
      },
      // 提交按钮
      handleSubmit() {
        if (!data.dialogFormDataAdd.compId) {
          errMsg("请选择客户");
          return;
        }
        if (!data.dialogFormDataAdd.LinkMan) {
          errMsg("请输入联系人")
          return
        }
        if (!data.dialogFormDataAdd.TelNo) {
          errMsg("请输入电话")
          return
        }
        if (!data.dialogFormDataAdd.Phone) {
          errMsg("请输入手机")
          return
        }
        if (!data.dialogFormDataAdd.Address) {
          errMsg("请输入地址")
          return
        }
        if (!data.dialogFormDataAdd.TransferNo) {
          errMsg("请输入货运单号")
          return
        }
        if (!data.dialogFormDataAdd.trcombId) {
          errMsg("请输入货运公司")
          return
        }
        if (!data.dialogFormDataAdd.trmthId) {
          errMsg("请输入运输方式")
          return
        }
        if (!data.dialogFormDataAdd.TranDate) {
          errMsg("请输入寄送时间")
          return
        }
        if (!data.dialogFormDataAdd.list.length) {
          errMsg("请添加sn列表信息")
          return
        }
        const params = { ...data.dialogFormDataAdd };

        tableApi.PreMachineApplyCommit(params).then((res) => {
          console.log(res, '提交res returnApi')
          if (res.data.code == 0) {
            successMsg("提交成功")
            data.dialogAdd = false
          }
        });
      },
      // 添加关闭回调
      dialogAddClose() {
        data.dialogFormDataAdd = { list: [] }
      },
      // 附件 保存事件
      sendBackSaveAdd() {
        const keys = Object.keys(data.conditionAdd);
        const res = keys.find((i) => {
          if (data.conditionAdd[i] === undefined) {
            return i;
          }
        });
        if (res || !data.conditionAdd.PreMachDesc) {
          errMsg("请输入");
          return;
        }
        // const BrandId = data.options.compid.filter(
        //   (i) => i.value == data.conditionAdd.BrandId
        // )[0].label;
        // const ProductId = data.options.ProductId.filter(
        //   (i) => i.value == data.conditionAdd.ProductId
        // )[0].label; //
        // const ModelNoId = data.options.ModelNoId.filter(
        //   (i) => i.value == data.conditionAdd.ModelNoId
        // )[0].label;

        // conditionAdd.BrandId
        // handleCompid

        // conditionAdd.ProductId
        // handleProductId

        // conditionAdd.ModelNoId
        // conditionAdd.Attach

        let BrandId = data.conditionAdd.BrandId
        let ProductId = data.conditionAdd.ProductId
        let ModelNoId = data.conditionAdd.ModelNoId

        let sn = data.conditionAdd.sn;

        let PreMachDesc = data.conditionAdd.PreMachDesc;

        let AttachName = ''
        let Attach = ''
        if (data.conditionAdd.Attach) {
          AttachName = data.conditionAdd.Attach.join(',')
          Attach = data.conditionAdd.Attach.map( i => {
            return data.fjData.find((item) => {
            if (item.Name == i) {
                return item;
              }
            }).id;
          })
          Attach = Attach.join(',')
        }
        // const AttachName = data.conditionAdd.Attach.join(",");
        
        // const Attach = data.conditionAdd.Attach.map((i) => {
        //   return data.fjData.find((item) => {
        //     if (item.Name == i) {
        //       return item;
        //     }
        //   }).id;
        // });
        const obj = {
          BrandId,
          ProductId,
          ModelNoId,
          AttachName,
          sn,
          PreMachDesc,
          Attach,
        };
        console.log('obj@--', obj)
        tableApi.SerialNoApplyCheck({ sn }).then((res) => {
          console.log(res, "sn测试");
          if (res.code != 0) {
            errMsg(res.message);
            return;
          }
          data.dialogFormDataAdd.list.push(obj);
          data.conditionAdd = {
            Attach: []
          }
          data.fjData = []
          console.log('@',data.conditionAdd)
          data.sendBackDialogAddFJ = false;
        });
      },
      // 附件添加关闭回调
      sendBackDialogAddFJClose() {
        data.conditionAdd = {};
        data.fjData = [];
      },
      handleSave(idArray = [{ Id: data.dialogFormData.Id }]) {
        console.log(data.dialogFormData.Stars, "Stars");
        const params = {
          idArray,
          back: data.dialogFormData.FeedBackProblem,
          result: data.dialogFormData.Result,
          Arrival: data.dialogFormData.Arrival || 1 + "",
          Smile: data.dialogFormData.Smile || 1 + "",
          Profession: data.dialogFormData.Profession || 1 + "",
          RoundSave: data.dialogFormData.RoundSave || 1 + "",
          Question: data.dialogFormData.Question || 1 + "",
          AllVisit: data.dialogFormData.AllVisit || 1 + "",
          stars: data.dialogFormData.Stars || 0,
        };
        tableApi
          .ServerRepairVisitAdd(params)
          .then((res) => {
            data.dialogFormVisible = false;
            successMsg("回访成功");
          })
          .catch((r) => {
            errMsg("回访失败");
          });
      },
      // 添加
      handleAdd() {
        data.dialogAdd = true;
      },
      // 添加--添加
      handleDialogAddFj() {
        console.log(data.options.compid, "opiii");
        data.sendBackDialogAddFJ = true;
      },
      tableSelection(selection) {
        data.tabelSelectionList = selection;
      },
    };

    return {
      ...toRefs(data),
      ...methods,
    };
  },
});
</script>

<style lang="scss" scoped="scoped">
.container-serve {
  width: 100%;
  height: 100%;

  .condition-list-container {
    width: 100%;
    height: auto;
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    border-radius: 5px;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    padding: 0.15625rem 0.125rem;
    overflow: hidden;
    box-sizing: border-box;

    .conditon-bontainer {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .condition-container-input {
        width: 270px;

        &:nth-last-child(1) {
          margin-top: 20px;
        }
      }
    }

    .btn-container {
      :deep(.el-button, el-button--primary) {
        border-radius: 10px;
      }
    }
  }

  .main-container {
    width: 100%;
    height: auto;

    .header-container {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      padding: 20px 10px;

      .title {
        color: rgb(4, 53, 250);
      }

      .btnHandle {
        cursor: pointer;
        width: 50px;
        height: 30px;
        border-radius: 10px;
        line-height: 30px;
        text-align: center;
        background-color: rgb(4, 53, 250);
        color: white;
      }
    }

    .tabel-container {
      :deep(.header-row-class-name) {
        background-color: rgb(100, 134, 232) !important;
        color: white !important;
      }

      :deep(.el-table--enable-row-transition) {
        border: rgb(100, 134, 232) solid 1px !important;
        box-sizing: border-box;
        border-radius: 2px;
      }
    }
  }
}

.condition-panel {
  .form-dialog-condition-one {
    display: flex;
    margin-top: 20px;
    // margin-bottom: 10px;
    width: 100%;
  }

  .form-dialog-condition-two {
    display: flex;
    width: 100%;
    margin: 10px 0;
  }

  .form-dialog-condition-three {
    display: flex;
    margin: 10px 0;
    flex-wrap: wrap;
    // border:1px solid red;
    width: 80%;

    .radio-panel-list {
      width: 50%;
      display: flex;
      margin: 18px 0;

      .label {
        margin-right: 20px;
        font-size: 16px;
        font-weight: bold;
        align-items: center;
      }
    }
  }

  .form-dialog-condition-four {
    display: flex;
    margin: 10px 0;

    .label {
      font-size: 16px;
      font-weight: bold;
      margin-right: 20px;
    }
  }
}

.data-show-panel {
  .serve-list {
    background-color: rgb(68, 102, 237);
    margin: 10px 0;
    color: white;
  }
}

.footer-container {
  display: flex;
  justify-content: center;

  .cancel-style {
    margin-right: 30px;
  }
}

.text-area-width {
  width: 400px;
}

.serve-list-add {
  display: flex;
  justify-content: end;
  margin-top: 20px;
  align-content: center;
  align-items: center;
  background-color: rgb(47, 78, 89);
  height: 26px;

  .add-style {
    margin-right: 20px;
  }

  .add-point {
    color: white;
    font-size: 18px;
    display: inline-block;
    width: 40px;
    cursor: pointer;
  }
}

.add-row {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 20px;
  justify-content: space-between;

  .text-container {
    display: flex;

    .text {
      font-size: 16px;
      font-weight: 800;
      width: 60px;
      text-align: center;
      margin-right: 8px;
    }
  }

  :deep(.el-textarea__inner) {
    width: 412px !important;
  }
}

.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
